module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[71]558.4bf4112.woff2";